<template>
    <div class="home">
        <div class="header">
            <div class="container">
                <div class="logo">
                    <div class="logo_1">
                        <img src="static/images/logo_1.png" alt="">
                    </div>
                    <div class="logo_2">
                        <img src="static/images/logo_2.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="main_body">
            <div class="list">
                <div class="container">
                    <ul>
                        <li v-for="item in list" :key="item.id">
                            <div class="img" @click="link(item.id)">
                                <img :src="item.thumb" alt="">
                            </div>
                            <div class="text">
                                <div class="h">{{item.title}}</div>
                                <div class="look" @click="link(item.id)">
                                    <img src="static/images/look.png" alt="">
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer">
                <div class="container">
                    <div class="text">
                        <p>天水市博物馆版权所有 未经许可禁止转载</p>
                        <p>通讯地址：甘肃省天水市秦州区伏羲路110号 邮政编码：741000</p>
                        <p>联系电话：0938-8291377 邮箱：jacob0528@sina.com</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default{
        data(){
            return{
                isiOS:false
            }
        },
        computed:{
            ...mapState(['list'])
        },
        mounted(){
            var u = navigator.userAgent;
            this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if(this.isiOS){
                this.$nextTick(function(){
                    var body = document.getElementById('body')
                    body.style.position = 'relative';
                    body.style.height = 'auto';
                })
            }
        },
        methods:{
            link(id){
                this.$router.push({
                    path:'/detail',
                    query:{
                        id:id
                    }
                })

                if(window.innerWidth <= 768){
                    this.fullScreen()
                }
            },
            //全屏
            fullScreen(){
                var el = document.documentElement;
                var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;      
                    if(typeof rfs != "undefined" && rfs) {
                        rfs.call(el);
                        this.isfullScreen = true
                    };
                return;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header{
        
        display:flex;
        height:280px;
        background:url('../../public/static/images/header_bc.jpg') center / cover;
        justify-content:center;
        align-items:center;
        .container{
            position: relative;
        }
        .logo{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;

            .logo_1 {
                margin-right:50px;
                img{
                    width: 80px;
                    display: block;
                }
            }
            .logo_2 {
                img{
                    width: 1000px;
                    display: block;
                }
            }
        }
        .p{
            position: absolute;
            right:0; top:0;
            font-size:14px;
            color:#fff;
        }
    }
    .main_body{
        background:#f5e3c4 url('../../public/static/images/body_bc.jpg') left bottom / 100%;
        overflow: hidden;
        .list{
            margin:85px 0;
            ul{
                display:flex;
                justify-content:space-between;
                align-items:flex-start;
                flex-wrap: wrap;
                li{
                    width:446px;
                    /* height:446px; */
                    margin-bottom:35px;
                    overflow: hidden;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, .12), 0 0 12px rgba(0, 0, 0, .04);
                    .img{
                        width:100%;
                        height:490px;
                        overflow: hidden;
                        cursor: pointer;
                        img{
                            width:100%;
                            display:block;
                            transition-duration:.3s;
                            &:hover{
                                transform:scale(1.1,1.1);
                            }
                        }
                    }
                    .text{
                        position: relative;
                        width:100%;
                        height:84px;
                        background-color:#a96a35;
                        padding:15px 25px;
                        .h{
                            font-size:16px;
                            color:#fff;
                            line-height:30px;
                        }
                        .look{
                            position: absolute;
                            right:25px; bottom:15px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    .footer{
        .text{
            border-top:4px solid #a96a35;
            padding:30px 0 100px;
            p{
                font-size:16px;
                color:#000000;
                text-align:center;
                line-height:30px;
            }
        }
    }

    @media(max-width:768px){
        .container{
            max-width:90%;
        }
        .header{
            display:flex;
            height:auto;
            padding: 30px 0;
            background:url('../../public/static/images/header_bc.jpg') center / cover;
            justify-content:center;
            align-items:center;
            .container{
                position: relative;
            }
            .logo{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                height: 100%;
                padding-top: 80px;


                .logo_2 {
                    img{
                        width: 100%;
                        display: block;
                    }
                }
                .logo_1{
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    margin: auto;
                    display:flex;
                    justify-content:flex-start;
                    img{
                        width: 60px;
                    }
                }
            }
            .p{
                position: absolute;
                right:15px; top:-30px;
                font-size:14px;
                color:#fff;
            }
        }

        .main_body{
            background:#f5e3c4 url('../../public/static/images/body_bc.jpg') left bottom / 100%;
            overflow: hidden;
            .list{
                margin:30px 0;
                ul{
                    display:flex;
                    justify-content:space-between;
                    align-items:flex-start;
                    flex-wrap: wrap;
                    li{
                        width:100%;
                        height:auto;
                        margin-bottom:35px;
                        overflow: hidden;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, .12), 0 0 12px rgba(0, 0, 0, .04);
                        .img{
                            width:100%;
                            height:auto;
                            overflow: hidden;
                            cursor: pointer;
                            img{
                                width:100%;
                                display:block;
                                transition-duration:.3s;
                                &:hover{
                                    transform:scale(1.1,1.1);
                                }
                            }
                        }
                        .text{
                            position: relative;
                            width:100%;
                            height:84px;
                            background-color:#a96a35;
                            padding:15px 25px;
                            .h{
                                font-size:16px;
                                color:#fff;
                                line-height:30px;
                            }
                            .look{
                                position: absolute;
                                right:25px; bottom:15px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }
</style>